import { primaryColor } from '../constants';

import {Link} from "react-router-dom";

const menuStyle = {
  display: 'flex',
  flexFlow: 'row wrap',
  justifyContent: "center",
  gap: "10px"
}

export function Menu({children, onClick}){
  return (
    <menu onClick={onClick} style={menuStyle}>
      {children}
    </menu>
  );
}

const menuItemStyle = {
  color: primaryColor,
  textDecoration: 'none'
}

export function MenuItem({ to, label, selected }){
  const style = {
    ...menuItemStyle,
    borderBottom: selected ? `3px ${primaryColor} solid`: ''
  }
  return (
    <Link to={to} style={style}>
      {label}
    </Link>
  );
}
